import QueslibPreview from '../question-selector/src/quesLibView.vue';

/* istanbul ignore next */
QueslibPreview.install = function(Vue) {
  Vue.component(QueslibPreview.name, QueslibPreview);
};

export default QueslibPreview;

